import styled from 'styled-components';

import { MediaQueryBreakpoints, Colors, maxWidth } from '@rockalingua/ui';

export const Background = styled.div`
  background-color: ${Colors.MAIN_VARIANTS[10]};
  width: 100vw;
  margin-left: calc(-50vw + 50%);
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 48px;
  padding: 48px;
  max-width: ${maxWidth}px;
  margin: 0 auto;

  @media only screen and (max-width: ${MediaQueryBreakpoints.sm}px) {
    flex-direction: column;
    padding: 24px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
`;

export const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  img {
    max-width: 300px;
    height: auto;
  }

  @media only screen and (max-width: ${MediaQueryBreakpoints.sm}px) {
    justify-content: center;
  }
`;
